import React from 'react';
import './About.css';

const About = () => {
  return (
    <main className="about-page">
      <div className="about-container">
        <section className="about-hero">
          <h1 className="about-title">Youth Supporting Roots</h1>
          <p className="about-subtitle">Generations Working Together</p>
        </section>
        
        <section className="about-content">
          <h2 className="section-title">About Us</h2>
          
          <div className="about-text">
            <p>
              Youth Supporting Roots, Inc. (YSR) is a nonprofit organization, established in 2023, located in Durham, NC. Our 
              leadership is governed by a seven-member board of directors of various backgrounds. The Board of Directors provides 
              oversight responsibilities for activities of the organization, ensuring Baby Boomers and Gen Z are cohorts.
            </p>
            
            <p>
              Altruism fosters a positive emotional state, leading to feelings of fulfillment and satisfaction. We seek to empower youth 
              altruism for BiPOC (brown, black, indigenous, and people of color) students ages 14 -16, through food pantry 
              involvement and intergenerational mentorship. Through this collaboration, we will foster community service and skill 
              development in a supportive environment.
            </p>
            
            <p>
              We strive to address the challenge of older volunteers, who, despite their compassion and experience, may lack the 
              physical stamina required at our food distribution sites. By recruiting younger Gen Z volunteers, we aim to provide 
              assistance and support to our seniors, enabling them to take shorter shifts and reduce heavy lifting. Additionally, this 
              initiative fosters intergenerational interactions and mentorship opportunities, benefiting both age groups.
            </p>
            
            <p>
              We hope to create a community where volunteers are paid for their service, generations work together, and no one 
              goes hungry.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default About;
